import { Routes } from '@angular/router';
import {
  ACCOUNTING_PATHS,
  ADMINISTRATION_PATHS,
  BANKING_PATHS,
  BRANCHES_PATHS,
  BUILDINGS_PATHS,
  CONTACTS_PATHS,
  CONTRACTORS_PATHS,
  CYCLE_PATHS,
  ERROR_PATHS,
  INSPECTIONS_PATHS,
  MEETINGS_PATHS,
  NOTIFICATIONS_PATHS,
  PROPERTIES_PATHS,
  ROOT_PATHS,
  UNITS_PATHS,
  EMAILS_PATHS,
  FOLLOW_UPS_PATHS,
  TASKS_PATHS,
  DOCUMENTS_PATHS,
  AGENT_CONFIGURATION_PATHS, MAILBOXES_PATHS,
  DRIVE_IMPORTS_PATHS,
  INVITE_PATHS,
} from './core/constants/paths.constants';
import { ERROR_URLS } from './core/constants/urls.constants';
import { RouteHelper } from './core/helpers/route.helper';

export const routes: Routes = [
  RouteHelper.withBaseLayout([
    {
      path: ROOT_PATHS.dashboard,
      data: { search: { title: 'Navigation.Dashboard', keywords: ['home', 'dashboard', 'start'] } },
      loadChildren: async () =>
        import('./features/dashboard/dashboard.routes').then((module) => module.DASHBOARD_ROUTES),
    },
    {
      path: PROPERTIES_PATHS.base,
      data: {
        search: {
          title: 'Navigation.Properties',
          keywords: ['properties', 'real estate', 'listings'],
        },
      },
      loadChildren: async () =>
        import('./features/properties/properties.routes').then(
          (module) => module.PROPERTIES_ROUTES,
        ),
    },
    {
      path: BUILDINGS_PATHS.base,
      data: {
        search: {
          title: 'Navigation.Buildings',
          keywords: ['buildings', 'structures', 'facilities'],
        },
      },
      loadChildren: async () =>
        import('./features/buildings/buildings.routes').then((module) => module.BUILDINGS_ROUTES),
    },
    {
      path: UNITS_PATHS.base,
      data: { search: { title: 'Navigation.Units', keywords: ['units', 'apartments', 'spaces'] } },
      loadChildren: async () =>
        import('./features/units/units.routes').then((module) => module.UNITS_ROUTES),
    },
    {
      path: CONTRACTORS_PATHS.base,
      data: {
        search: { title: 'Navigation.Contractors', keywords: ['contractors', 'handwerker', 'dienstleister', 'gewerk'] },
      },
      loadChildren: async () =>
        import('./features/contractors/contractors.routes').then((module) => module.CONTRACTORS_ROUTES),
    },
    {
      path: CONTACTS_PATHS.base,
      data: {
        search: { title: 'Navigation.Contacts', keywords: ['contacts', 'people', 'directory'] },
      },
      loadChildren: async () =>
        import('./features/contacts/contacts.routes').then((module) => module.CONTACTS_ROUTES),
    },
    {
      path: BRANCHES_PATHS.base,
      data: {
        search: { title: 'Navigation.Branches', keywords: ['branches', 'locations', 'offices'] },
      },
      loadChildren: async () =>
        import('./features/branches/branches.routes').then((module) => module.BRANCHES_ROUTES),
    },
    {
      path: ACCOUNTING_PATHS.base,
      data: {
        search: {
          title: 'Navigation.Accounting',
          keywords: ['accounting', 'finance', 'ledger', 'financial'],
        },
      },
      loadChildren: async () =>
        import('./features/accounting/accounting.routes').then(
          (module) => module.ACCOUNTING_ROUTES,
        ),
    },
    {
      path: BANKING_PATHS.base,
      data: {
        search: {
          title: 'Navigation.Banking',
          keywords: ['banking', 'payments', 'transactions', 'accounts'],
        },
      },
      loadChildren: async () =>
        import('./features/banking/banking.routes').then((module) => module.BANKING_ROUTES),
    },
    {
      path: CYCLE_PATHS.base,
      data: {
        search: {
          title: 'Navigation.Cycle',
          keywords: ['cycle', 'billing', 'periods', 'invoices'],
        },
      },
      loadChildren: async () =>
        import('./features/cycle/cycle.routes').then((module) => module.CYCLE_ROUTES),
    },
    {
      path: MEETINGS_PATHS.base,
      data: {
        search: {
          title: 'Navigation.Meetings',
          keywords: ['meetings', 'calendar', 'events', 'schedule'],
        },
      },
      loadChildren: async () =>
        import('./features/meetings/meetings.routes').then((module) => module.MEETINGS_ROUTES),
    },
    {
      path: INSPECTIONS_PATHS.base,
      data: {
        search: {
          title: 'Navigation.Inspections',
          keywords: ['inspections', 'audits', 'checks', 'compliance'],
        },
      },
      loadChildren: async () =>
        import('./features/inspections/inspections.routes').then(
          (module) => module.INSPECTIONS_ROUTES,
        ),
    },
    {
      path: EMAILS_PATHS.base,
      data: { search: { title: 'Navigation.Emails', keywords: ['email', 'mail', 'inbox', 'posteingang'] } },
      loadChildren: async () =>
        import('./features/emails/emails.routes').then((module) => module.EMAILS_ROUTES),
    },
    {
      path: FOLLOW_UPS_PATHS.base,
      data: { search: { title: 'Navigation.FollowUps', keywords: ['wiedervorlage', 'wiedervorlagen', 'follow up'] } },
      loadChildren: async () =>
        import('./features/follow-ups/follow-ups.routes').then((module) => module.FOLLOW_UPS_ROUTES),
    },
    {
      path: TASKS_PATHS.base,
      data: { search: { title: 'Navigation.Tasks', keywords: ['aufgaben', 'tasks', 'kanban', 'todo'] } },
      loadChildren: async () =>
        import('./features/tasks/tasks.routes').then((module) => module.TASKS_ROUTES),
    },
    {
      path: DOCUMENTS_PATHS.base,
      data: { search: { title: 'Navigation.Documents', keywords: ['dokumente', 'dms', 'dateien', 'documents'] } },
      loadChildren: async () =>
        import('./features/documents/documents.routes').then((module) => module.DOCUMENTS_ROUTES),
    },
    {
      path: AGENT_CONFIGURATION_PATHS.base,
      data: { search: { title: 'AgentConfiguration.Title', keywords: ['agent', 'ki', 'playbook'] } },
      loadChildren: async () =>
        import('./features/agent-configuration/agent-configuration.routes').then((module) => module.AGENT_CONFIGURATION_ROUTES),
    },
    {
      path: MAILBOXES_PATHS.base,
      data: { search: { title: 'Navigation.Mailboxes', keywords: ['postfach', 'mailbox', 'exchange', 'sync'] } },
      loadChildren: async () =>
        import('./features/mailboxes/mailboxes.routes').then((module) => module.MAILBOXES_ROUTES),
    },
    {
      path: DRIVE_IMPORTS_PATHS.base,
      data: { search: { title: 'Navigation.DriveImports', keywords: ['drive', 'import', 'google'] } },
      loadChildren: async () =>
        import('./features/drive-imports/drive-imports.routes').then((module) => module.DRIVE_IMPORTS_ROUTES),
    },
    {
      path: NOTIFICATIONS_PATHS.base,
      data: {
        search: {
          title: 'Navigation.Notifications',
          keywords: ['notifications', 'alerts', 'messages'],
        },
      },
      loadChildren: async () =>
        import('./features/notifications/notifications.routes').then(
          (module) => module.NOTIFICATIONS_ROUTES,
        ),
    },
    {
      path: ADMINISTRATION_PATHS.base,
      data: {
        search: {
          title: 'Navigation.Administration',
          keywords: ['administration', 'settings', 'management', 'config'],
        },
      },
      loadChildren: async () =>
        import('./features/administration/administration.routes').then(
          (module) => module.ADMINISTRATION_ROUTES,
        ),
    },
  ]),
  {
    // PUBLIC: the invite landing page — resolves the opaque token anonymously and sends
    // the person through the IdP round-trip before accepting with the fresh bearer
    path: INVITE_PATHS.base,
    loadChildren: async () =>
      import('./features/invite/invite.routes').then((module) => module.INVITE_ROUTES),
  },
  {
    path: ERROR_PATHS.base,
    loadChildren: async () =>
      import('./features/error/error.routes').then((module) => module.ERRORS_ROUTES),
  },
  { path: '**', redirectTo: ERROR_URLS.notFound, data: { search: { include: false } } },
];
